import { useLocation, useNavigate } from 'react-router-dom';
import { homeForGroups } from '../../auth/routing';
import ConfirmAccount from './ConfirmAccount';
import loginImage from '../../assets/login image bhima.png';
import styles from '../../styles/authShell.module.css';

export default function ConfirmAccountPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const initialPhone = location.state?.initialPhone || '';

  const handleDone = (session) => {
    const home = homeForGroups(session.groups);
    navigate(home || '/login', { replace: true });
  };

  return (
    <div className={styles.page}>
      <div className={styles.panel}>
        <img src={loginImage} alt="" className={styles.panelImage} />
      </div>
      <div className={styles.formSide}>
        <ConfirmAccount initialPhone={initialPhone} onDone={handleDone} />
      </div>
    </div>
  );
}
